module.exports = __webpack_public_path__ + "img/74.4.NH3-N.0e354036.png";